import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./AllBlogs.module.css";

function AllBlogs() {
  const [allBlogs, setAllBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_STRAPI_API_URL;
        const baseUrl = process.env.REACT_APP_STRAPI_BASE_URL;

        const response = await fetch(
          `${apiUrl}/articles?populate=*&pagination[pageSize]=100`,
          {
            headers: {
              Accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch blogs");
        }

        const result = await response.json();

        // Transform Strapi data to match component structure
        const transformedBlogs = result.data.map((article) => ({
          id: article.id,
          documentId: article.documentId,
          slug: article.slug,
          image: article.cover?.url
            ? `${baseUrl}${article.cover.url}`
            : "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&q=80",
          title: article.title,
          category: article.category?.name || "Uncategorized",
          publishedAt: article.publishedAt,
        }));

        setAllBlogs(transformedBlogs);
        setError(null);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (loading) {
    return (
      <div className={styles.allBlogsContainer}>
        <div className={styles.loading}>Loading blogs...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.allBlogsContainer}>
        <div className={styles.error}>Error loading blogs: {error}</div>
      </div>
    );
  }

  return (
    <div className={styles.allBlogsContainer}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <div className={styles.iconGrid}>
            <span className={styles.gridIcon}>⊞</span>
          </div>
          <h2 className={styles.sectionTitle}>All Blogs</h2>
        </div>
        <div className={styles.controls}>
          <button className={styles.controlBtn}>
            <span>≡</span>
          </button>
          <button className={styles.controlBtn}>
            <span>↕</span>
          </button>
          <button className={styles.controlBtn}>
            <span>🔍</span>
          </button>
        </div>
      </div>

      <div className={styles.blogsGrid}>
        {allBlogs.map((blog) => (
          <Link
            key={blog.id}
            to={`/blogs/${blog.slug}`}
            className={styles.blogCard}
          >
            <div className={styles.imageContainer}>
              <img
                src={blog.image}
                alt={blog.title}
                className={styles.blogImage}
              />
            </div>
            <div className={styles.blogContent}>
              <h3 className={styles.blogTitle}>{blog.title}</h3>
              <p className={styles.blogDate}>
                {new Date(blog.publishedAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
              <span className={styles.readMore}>Read More</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default AllBlogs;
